import { Stack, Typography, Box } from '@mui/material'
import { useEffect, useState } from 'react'
import UserMangTable from './UserMangTable';
import AddIcon from '@mui/icons-material/Add';
import AddEditUserModal from './AddNewUserModal';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import { AddLookUpBtn } from '../../components/styledComponent/Button';

const UserManagement = () => {
  const [open, setOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any | null>()
  const [userList, setUserList] = useState<any | null>()
  const [loading, setLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState(0)
  const [count, setCount] = useState<any>(0);
  const [take, setTake] = useState(10)

  const { get } = useCrudForm();

  const refetchData = () => {
    get({
      endpoints: `${endpoints.user.get}?skip=${skip * take}&take=${take}`,
      onSuccess: (data: any) => {
        setUserList(data.data.list)
        setCount(data.data.count)
        setLoading(false)
      },
      onError: (error: any) => {
        console.log(error)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    refetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, take])

  return (
    <>
      <Typography variant="h5" component="h5" mb={1} fontWeight={600}>User Management</Typography>
      <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
        <Stack direction="row" mb={3} spacing={2} sx={{ justifyContent: "end", alignItems: "center" }}>
          <AddLookUpBtn onClick={() => setOpen(true)}>
            <AddIcon />
            <Typography>New User</Typography>
          </AddLookUpBtn>
        </Stack>
        <UserMangTable refetchData={refetchData} loading={loading} skip={skip} take={take} setTake={setTake} setSkip={setSkip} count={count} setOpen={setOpen} setSelectedItem={setSelectedItem} rows={userList} />
      </Box>
      {open ? <AddEditUserModal refetchData={refetchData} open={open} setOpen={setOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} /> : null}
    </>
  )
}

export default UserManagement
